import { ASK_INPUT_DRAFTS_DB_NAME } from '#pplx/frontend/apps/ask/ask-input/ask-input-drafts/types.js';
import { deleteAccountStore } from '#pplx/frontend/browser-storage/accountScopedIDB.js';
import { SafeLocalStorage } from '#pplx/frontend/browser-storage/localStorage.js';
const DRAFT_DATABASE_ACCOUNT_KEY_PREFIX = 'pplx:ask-input-draft-account:';
function accountRegistryKey(accountId) {
    return `${DRAFT_DATABASE_ACCOUNT_KEY_PREFIX}${accountId}`;
}
export function rememberAskInputDraftDatabase(accountId) {
    SafeLocalStorage.setItem(accountRegistryKey(accountId), '1', { global: true });
}
export async function deleteAskInputDraftDatabase(accountId) {
    const deleted = await deleteAccountStore(ASK_INPUT_DRAFTS_DB_NAME, accountId);
    if (deleted) {
        SafeLocalStorage.removeItem(accountRegistryKey(accountId), { global: true });
    }
    return deleted;
}
function deleteDefaultDraftDatabase() {
    return new Promise((resolve) => {
        const request = indexedDB.deleteDatabase(ASK_INPUT_DRAFTS_DB_NAME);
        request.onsuccess = () => resolve(true);
        request.onerror = () => resolve(false);
        request.onblocked = () => resolve(true);
    });
}
export async function deleteAllAskInputDraftDatabases() {
    const accountIds = SafeLocalStorage.keys()
        .filter((key) => key.startsWith(DRAFT_DATABASE_ACCOUNT_KEY_PREFIX))
        .map((key) => key.slice(DRAFT_DATABASE_ACCOUNT_KEY_PREFIX.length));
    const results = await Promise.all([
        deleteDefaultDraftDatabase(),
        ...accountIds.map(deleteAskInputDraftDatabase),
    ]);
    return results.every(Boolean);
}
//# sourceMappingURL=askInputDraftDatabase.js.map